var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrowed"},[_c('div',{staticClass:"arrow",staticStyle:{"border-color":"#027c00 #027c00 transparent transparent !important"}})])}]

export { render, staticRenderFns }